export default {
  title: {
    home: 'Home',
    notFound: 'Not found',
    error: 'Error',
    legal: 'Legals'
  },
  message: {
    noCampaigns: 'There are no associated campaigns for the client yet {customerName}',
    specialDayOfferTitle: 'Hire your renting now and get a €150 fuel card.',
    specialDaySpecialCampaingOfferTitle: 'Hire your renting now and get a €60 fuel card.',
    specialDayOfferTitle2: 'Only during this month.',
    specialDayQuote:
      'SOLRED fuel card that you can use in the EE.SS. of Repsol, Campsa and Petronor.',
    specialDayDetailTitle: 'Hire your renting now and get a €150 fuel card.',
    specialDayDetailSpecialCampaingTitle: 'Hire your renting now and get a €60 fuel card.',
    generic: {
      loadingData: 'Loading data'
    },
    warning: {
      visibilityDate: 'Only until {date}!'
    }
  },
  language: {
    en: 'English',
    es: 'Spanish'
  },
  ui: {
    button: {
      btnBack: 'Back',
      btnSave: 'Save',
      btnCancel: 'Cancel',
      btnAccept: 'Accept',
      btnClose: 'Close',
      btnCreate: 'Create',
      btnConfirm: 'Confirm',
      btnChange: 'Change',
      btnDelete: 'Delete',
      btnRecord: 'Save',
      btnClear: 'Clear',
      btnCallus: 'Callus',
      btnResetFilters: 'Delete filters'
    },
    label: {
      typeVehicle: 'Offer type',
      mark: 'Brand',
      modelName: 'Model',
      province: 'Province',
      bodyStyleVehicle: 'Body style',
      typeFuel: 'Fuel type',
      emissionsFilter: 'Emissions filter',
      term: 'Term (months)',
      kilometers: 'Kilometers',
      rangePrice: 'Price range',
      onlineContract: 'Online contract',
      moreInfo: 'I want more information',
      termInMonths: 'Term',
      months: 'months',
      yearKms: 'Km/year',
      km: 'Km',
      euro: '€',
      timeMonth: '/month',
      iva: 'IVA',
      ivaIncluded: 'IVA included',
      igcIncluded: 'IGIC included',
      ivaNotIncluded: 'IVA not included',
      igcNotIncluded: 'IGIC not included',
      initialPayment: 'Initial payment',
      campaignValidIVA: 'Offer valid in Peninsula and Baleares until {date}',
      campaignValidIGC: 'Offer valid in Canarias until {date}',
      igic: 'IGIC',
      deposit: 'Deposit',
      offert: 'Offert:'
    },
    select: {
      noResultPrincing: 'No more results'
    },
    placeholder: {}
  },
  error: {
    undefined: 'Oops! Something went wrong!',
    notFound: "This page doesn't exist.",
    campaignNotFound: 'Campaign not found'
  },
  success: {}
};
